import type { IconData } from '@stacksjs/iconify-core'

export const arrowheadsDownChevron: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1 9V0l7 7l7-7v9l-7 7z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default arrowheadsDownChevron
